var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7775 1.58395C3.7022 1.53371 3.61467 1.50486 3.52426 1.50047C3.43384 1.49608 3.34393 1.51631 3.26412 1.55902C3.1843 1.60172 3.11758 1.66529 3.07106 1.74295C3.02455 1.8206 2.99999 1.90943 3 1.99995V9.99995C2.99999 10.0905 3.02455 10.1793 3.07106 10.257C3.11758 10.3346 3.1843 10.3982 3.26412 10.4409C3.34393 10.4836 3.43384 10.5038 3.52426 10.4994C3.61467 10.495 3.7022 10.4662 3.7775 10.416L9.7775 6.41595C9.84598 6.37029 9.90213 6.30843 9.94096 6.23586C9.97979 6.16329 10.0001 6.08226 10.0001 5.99995C10.0001 5.91765 9.97979 5.83661 9.94096 5.76404C9.90213 5.69147 9.84598 5.62961 9.7775 5.58395L3.7775 1.58395ZM4 9.06545V2.93445L8.6 5.99995L4 9.06545Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.fdfeaca2cdce7adb83876e10aef6685c.svg";
export { ForwardRef as ReactComponent };